// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.landlord.v1.CappsLandlordApplicationDataWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  CappsLandlordApplicationDataWebApiHandler_getActiveApplications,
  CappsLandlordApplicationDataWebApiHandler_getActiveApplications_Path,
  CappsLandlordApplicationDataWebApiHandler_getApplicationStatus,
  CappsLandlordApplicationDataWebApiHandler_getApplicationStatus_Path,
  CappsLandlordApplicationDataWebApiHandler_getArchivedApplications,
  CappsLandlordApplicationDataWebApiHandler_getArchivedApplications_Path,
  CappsLandlordApplicationDataWebApiHandler_getCompletedApplications,
  CappsLandlordApplicationDataWebApiHandler_getCompletedApplications_Path,
} from '@zg-rentals/ts-capps-client';

import type {
  ApplicationsForListingResponseDto,
  ApplicationStatusResponseDto,
  ListingAlias,
} from '@zg-rentals/ts-capps-client';

interface GetActiveApplicationsParams {
  listingAlias: ListingAlias;
}
interface GetApplicationStatusParams {
  applicationId: string;
  listingAlias: ListingAlias;
}
interface GetArchivedApplicationsParams {
  listingAlias: ListingAlias;
}
interface GetCompletedApplicationsParams {
  listingAlias: ListingAlias;
}

export type CappsLandlordApplicationDataWebApiHandler_getActiveApplications_Options = UseQueryOptions<
  ApplicationsForListingResponseDto,
  unknown,
  ApplicationsForListingResponseDto,
  readonly [string, GetActiveApplicationsParams]
>;

const CappsLandlordApplicationDataWebApiHandler_getActiveApplications_GetKey = (
  getParams: GetActiveApplicationsParams,
) => [CappsLandlordApplicationDataWebApiHandler_getActiveApplications_Path, getParams] as const;

export const CappsLandlordApplicationDataWebApiHandler_getActiveApplications_queryOptions = (
  getParams: GetActiveApplicationsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsLandlordApplicationDataWebApiHandler_getActiveApplications_GetKey(getParams),
    queryFn: () => CappsLandlordApplicationDataWebApiHandler_getActiveApplications(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useCappsLandlordApplicationDataWebApiHandler_getActiveApplications = (
  getParams: GetActiveApplicationsParams,
  {
    httpClient,
    ...options
  }: Omit<CappsLandlordApplicationDataWebApiHandler_getActiveApplications_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...CappsLandlordApplicationDataWebApiHandler_getActiveApplications_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useCappsLandlordApplicationDataWebApiHandler_getActiveApplications.getKey =
  CappsLandlordApplicationDataWebApiHandler_getActiveApplications_GetKey;

export type CappsLandlordApplicationDataWebApiHandler_getApplicationStatus_Options = UseQueryOptions<
  ApplicationStatusResponseDto,
  unknown,
  ApplicationStatusResponseDto,
  readonly [string, GetApplicationStatusParams]
>;

const CappsLandlordApplicationDataWebApiHandler_getApplicationStatus_GetKey = (getParams: GetApplicationStatusParams) =>
  [CappsLandlordApplicationDataWebApiHandler_getApplicationStatus_Path, getParams] as const;

export const CappsLandlordApplicationDataWebApiHandler_getApplicationStatus_queryOptions = (
  getParams: GetApplicationStatusParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsLandlordApplicationDataWebApiHandler_getApplicationStatus_GetKey(getParams),
    queryFn: () => CappsLandlordApplicationDataWebApiHandler_getApplicationStatus(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useCappsLandlordApplicationDataWebApiHandler_getApplicationStatus = (
  getParams: GetApplicationStatusParams,
  {
    httpClient,
    ...options
  }: Omit<CappsLandlordApplicationDataWebApiHandler_getApplicationStatus_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...CappsLandlordApplicationDataWebApiHandler_getApplicationStatus_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useCappsLandlordApplicationDataWebApiHandler_getApplicationStatus.getKey =
  CappsLandlordApplicationDataWebApiHandler_getApplicationStatus_GetKey;

export type CappsLandlordApplicationDataWebApiHandler_getArchivedApplications_Options = UseQueryOptions<
  ApplicationsForListingResponseDto,
  unknown,
  ApplicationsForListingResponseDto,
  readonly [string, GetArchivedApplicationsParams]
>;

const CappsLandlordApplicationDataWebApiHandler_getArchivedApplications_GetKey = (
  getParams: GetArchivedApplicationsParams,
) => [CappsLandlordApplicationDataWebApiHandler_getArchivedApplications_Path, getParams] as const;

export const CappsLandlordApplicationDataWebApiHandler_getArchivedApplications_queryOptions = (
  getParams: GetArchivedApplicationsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsLandlordApplicationDataWebApiHandler_getArchivedApplications_GetKey(getParams),
    queryFn: () => CappsLandlordApplicationDataWebApiHandler_getArchivedApplications(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useCappsLandlordApplicationDataWebApiHandler_getArchivedApplications = (
  getParams: GetArchivedApplicationsParams,
  {
    httpClient,
    ...options
  }: Omit<CappsLandlordApplicationDataWebApiHandler_getArchivedApplications_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...CappsLandlordApplicationDataWebApiHandler_getArchivedApplications_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useCappsLandlordApplicationDataWebApiHandler_getArchivedApplications.getKey =
  CappsLandlordApplicationDataWebApiHandler_getArchivedApplications_GetKey;

export type CappsLandlordApplicationDataWebApiHandler_getCompletedApplications_Options = UseQueryOptions<
  ApplicationsForListingResponseDto,
  unknown,
  ApplicationsForListingResponseDto,
  readonly [string, GetCompletedApplicationsParams]
>;

const CappsLandlordApplicationDataWebApiHandler_getCompletedApplications_GetKey = (
  getParams: GetCompletedApplicationsParams,
) => [CappsLandlordApplicationDataWebApiHandler_getCompletedApplications_Path, getParams] as const;

export const CappsLandlordApplicationDataWebApiHandler_getCompletedApplications_queryOptions = (
  getParams: GetCompletedApplicationsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsLandlordApplicationDataWebApiHandler_getCompletedApplications_GetKey(getParams),
    queryFn: () => CappsLandlordApplicationDataWebApiHandler_getCompletedApplications(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useCappsLandlordApplicationDataWebApiHandler_getCompletedApplications = (
  getParams: GetCompletedApplicationsParams,
  {
    httpClient,
    ...options
  }: Omit<CappsLandlordApplicationDataWebApiHandler_getCompletedApplications_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...CappsLandlordApplicationDataWebApiHandler_getCompletedApplications_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useCappsLandlordApplicationDataWebApiHandler_getCompletedApplications.getKey =
  CappsLandlordApplicationDataWebApiHandler_getCompletedApplications_GetKey;
